// extracted by mini-css-extract-plugin
export default {"head":"Head_head__yNCaL"};